@if (visible()) {
  <div style="width: 100%">
    <nz-row [id]="table.tableCode" [nzGutter]="[16, 16]">
      @for (record of visibleRecords(); track $index) {
        <nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="8" nzXl="8" nzXXl="8">
          <div class="cards-container">
            <div class="credit-request-card">
              <div class="credit-request-card__header">
                <div class="credit-request-card__icon">
                  <app-icon [iconName]="record?.recordData?.creditTypeIcon"></app-icon>
                </div>
                <h3 class="credit-request-card__title">{{ record?.recordData?.creditProductName }}</h3>
              </div>

              <div class="credit-request-card__info">
                @for (rowField of rowFields; track $index) {
                  <div class="credit-request-card__row">
                    <span class="credit-request-card__label">{{ rowField?.[1] }}:</span>
                    <span class="credit-request-card__value">{{ record?.recordData?.[rowField?.[0]] }}</span>
                  </div>
                }
                <div class="credit-request-card__row">
                  <span class="credit-request-card__label">{{ ammountField?.[1] }}</span>
                  <span class="credit-request-card__value credit-request-card__value--highlight">
                    {{ record?.recordData?.[ammountField?.[0]] | currency: 'COP' : 'symbol-narrow' : '1.0-0' }}
                  </span>
                </div>
              </div>

              <div class="card-actions">
                <div class="card-actions__left">
                  <!-- `isActionVisible` combina la visibilidad de la acción con su restricción
                       por registro y sigue la propagación; la condición escrita a mano sólo
                       entendía `==` e ignoraba si la acción estaba oculta. -->
                  @for (action of inlineActions; track $index) {
                    @if (isMainAction(action) && isActionVisible(action, record)) {
                      <div
                        class="cardAction"
                        [ngClass]="mainActionClass(record)"
                        (click)="
                          tableActionSelected({
                            actionCode: action.actionCode,
                            recordId: record.recordId,
                            recordData: record.recordData,
                          })
                        "
                        (keydown.enter)="
                          tableActionSelected({
                            actionCode: action.actionCode,
                            recordId: record.recordId,
                            recordData: record.recordData,
                          })
                        "
                        tabindex="0"
                        role="button"
                      >
                        <app-icon [iconName]="mainActionIcon(action, record)"></app-icon>
                        <span>{{ mainActionTitle(action, record) }}</span>
                      </div>
                    }
                  }
                </div>
                <div class="card-actions__right">
                  @for (action of inlineActions; track $index) {
                    @if (isSecondaryActionVisible(action, record)) {
                      <div
                        class="cardAction round"
                        (click)="
                          tableActionSelected({
                            actionCode: action.actionCode,
                            recordId: record.recordId,
                            recordData: record.recordData,
                          })
                        "
                        (keydown.enter)="
                          tableActionSelected({
                            actionCode: action.actionCode,
                            recordId: record.recordId,
                            recordData: record.recordData,
                          })
                        "
                        tabindex="0"
                        role="button"
                      >
                        <app-icon [iconName]="action?.iconName"></app-icon>
                        <span>{{ action.actionTitle }}</span>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </nz-col>
      }
    </nz-row>
  </div>
}
